/*******************
 Desktop Scroll hide
 ********************/

// window position
let position = window.scrollY;
const header = document.querySelector('#header');
// special behavior on pdp
const productPage = header.classList.contains('pdp');

function scrollHide() {
    // when scrolling down, hide header if past announcement
    const currentPosition = window.scrollY;
    if (currentPosition > position && header.getBoundingClientRect().top <= 0) {
        header.classList.add('active');
    } else {
        header.classList.remove('active');
    }
    position = currentPosition;
}

window.addEventListener('scroll', scrollHide);

/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown - open
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.closest('.sliderNavDropdown').querySelector('.sliderNavDropdownLinks').classList.add('active');
    });
});

// mobile slider nested dropdown - close
document.querySelectorAll(".sliderNavDropdownLinksReturn").forEach(element => {
    element.addEventListener("click", function () {
        element.closest('.sliderNavDropdownLinks').classList.remove('active');
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
    // update button aria
    document.querySelector('#headerMenu').setAttribute('aria-expanded', 'true');
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
    // update button aria
    document.querySelector('#headerMenu').setAttribute('aria-expanded', 'false');
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});


/**************
 Search
 ***************/

// use section id to fetch template
const headerSectionId = header.dataset.sectionId;

// shop button opens/closes search bar
document.querySelector('#headerIconsSearch').addEventListener('click', () => {
    document.querySelector('#headerSearch').classList.toggle('active');
    // focus on input
    document.querySelector('#headerSearchFormInput').focus();
})

// close button for search
document.querySelector('#headerSearchExit').addEventListener('click', () => {
    document.querySelector('#headerSearch').classList.remove('active');
    document.querySelector('#headerSearchMain').setAttribute('aria-expanded', 'false');
    document.querySelector('#headerIconsSearch').focus();
})

// listen for predictive search
document.querySelector('#headerSearchFormInput').addEventListener('input', async function () {

    let searchTerm = this.value.trim();

    // if no search term, clear results and close dropdown
    if (!searchTerm.length) {
        document.querySelector('#headerSearchResults').innerHTML = '';
        document.querySelector('#headerSearchResults').classList.remove('active');
        document.querySelector('#headerSearchResultsCount').innerHTML = '';
        // update aria label
        document.querySelector('#headerSearchMain').setAttribute('aria-expanded', 'false');
        return;
    }

    // fetch template
    await fetch(window.Shopify.routes.root + `search/suggest?q=${(searchTerm)}&type=product&section_id=${headerSectionId}`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {
            // create temp div to parse html
            const html = document.createElement('div');
            html.innerHTML = text;

            // use only rendered search section
            let searchHTML = html.querySelector('#headerSearchResults');

            // insert search results
            if (searchHTML && searchHTML.innerHTML.trim().length) {
                document.querySelector(`#headerSearchResults`).innerHTML = searchHTML.innerHTML;
                // show results
                document.querySelector('#headerSearchResults').classList.add('active');
                document.querySelector('#headerSearchMain').setAttribute('aria-expanded', 'true');

                // announce search count
                let resultCount = html.querySelectorAll('.headerSearchResultsProductsItem').length;
                document.querySelector('#searchAnnouncer').textContent = resultCount > 0
                    ? `${resultCount} search suggestions available. Use the tab key to review.`
                    : 'No search suggestions found.';
            }

        })
        .catch(e => {
            console.error(e);
        });
});

// listen for search submit
document.querySelector('#headerSearchForm')?.addEventListener('submit', function (e) {
    e.preventDefault();

    let fomData = new FormData(this);
    let searchTerm = fomData.get('q');

    // Empty search
    if (!searchTerm.length) {
        return;
    }

    window.location.href = `/search?q=${(searchTerm)}`

});

/*************************************
 ADA Escape content skip & menu tabbing
 **************************************/

// buttons on nav active menu for keyboard users
document.querySelectorAll('.headerNavLinkTitle')?.forEach(el => {
    el.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            this.setAttribute('aria-expanded', 'false');
            return;
        }
        document.querySelectorAll('.headerNavLinkTitle').forEach(el => {
            if (el === this) {
                el.classList.add('active');
                el.setAttribute('aria-expanded', 'true');
            } else {
                el.classList.remove('active');
                el.setAttribute('aria-expanded', 'false');
            }
        })
    })
})


// escape key changes focus to on main content skip
document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        console.log('escape!')
        document.querySelector('.mainContentFocus')?.focus();
        //  close any open menu
        document.querySelectorAll('.headerNavLinkTitle').forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-expanded', 'false');
        })
    }
});